import { createContext, useContext } from "react";

export const GeoserverConfigContext = createContext(null);

export function useGeoServerConfig() {
  return useContext(GeoserverConfigContext);
}
